import { useEffect, useState } from "react";
import { toast } from "sonner";
import { GripVertical } from "lucide-react";
import { api, imgUrl, eur, errMsg } from "@/lib/api";
import { BRANDS } from "@/lib/i18n";

const move = (ids, from, to) => {
  const out = ids.filter((id) => id !== from);
  out.splice(out.indexOf(to) + (ids.indexOf(from) < ids.indexOf(to) ? 1 : 0), 0, from);
  return out;
};

const Row = ({ p, drag, setDrag, onDrop }) => (
  <li data-testid={`catalog-order-row-${p.id}`} draggable onDragStart={() => setDrag(p.id)} onDragEnd={() => setDrag(null)}
    onDragOver={(e) => drag && e.preventDefault()} onDrop={() => onDrop(p.id)}
    className={`flex items-center gap-3 px-3 py-2 border-b border-[#3B4157] last:border-0 cursor-grab active:cursor-grabbing transition-opacity ${drag === p.id ? "opacity-40" : "hover:bg-[#30354A]"}`}>
    <GripVertical className="w-4 h-4 text-slate-500 shrink-0" />
    <img src={imgUrl(p.images?.[0])} alt="" className="w-10 h-10 object-contain bg-[#1F2230]" />
    <span className="flex-1 text-sm">{p.name}</span>
    <span className="font-mono-x text-xs text-slate-400">{p.price_on_request ? "Klausti kainos" : eur(p.price)}</span>
  </li>
);

export default function AdminCatalogOrder() {
  const [list, setList] = useState([]);
  const [drag, setDrag] = useState(null);
  useEffect(() => { api.get("/products").then((r) => setList(r.data)); }, []);

  const dropOn = async (brand, target) => {
    const from = drag;
    setDrag(null);
    if (!from || from === target) return;
    const group = list.filter((p) => p.brand === brand);
    if (!group.some((p) => p.id === from)) return;
    const ids = move(group.map((p) => p.id), from, target);
    const byId = Object.fromEntries(list.map((p) => [p.id, p]));
    const rest = list.filter((p) => p.brand !== brand);
    const next = [...rest, ...ids.map((id) => byId[id])];
    const all = BRANDS.flatMap((b) => next.filter((p) => p.brand === b)).concat(next.filter((p) => !BRANDS.includes(p.brand)));
    setList(all);
    try { await api.post("/admin/catalog-order", { ids: all.map((p) => p.id) }); toast.success("Katalogo tvarka išsaugota"); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-catalog-order">
      <h1 className="font-display font-black uppercase text-4xl">Katalogo tvarka</h1>
      <p className="text-sm text-slate-400 mt-2">Tempkite sėdynes pele – tokia tvarka jos bus rodomos kataloge (rikiuojant „Rekomenduojamos“). Proboss variantai pagal traktoriaus markę rodomi kartu su savo baziniu modeliu.</p>
      <div className="mt-8 space-y-8">
        {BRANDS.map((b) => {
          const items = list.filter((p) => p.brand === b);
          if (!items.length) return null;
          return (
            <section key={b} data-testid={`catalog-order-brand-${b}`}>
              <h2 className="text-xs uppercase tracking-[0.2em] text-orange-500 mb-2">{b}</h2>
              <ul className="border border-[#3B4157] bg-[#292D3C]">
                {items.map((p) => <Row key={p.id} p={p} drag={drag} setDrag={setDrag} onDrop={(t) => dropOn(b, t)} />)}
              </ul>
            </section>
          );
        })}
      </div>
    </div>
  );
}
